module.exports = __webpack_public_path__ + "static/media/SpenLeaf-2.5a515c73.webp";